import './searchStart.scss'
import React, { useState, useEffect } from 'react'
import { Container, Button, Typography } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import {
  Check,
  FavoriteOutlined,
  Search,
  ShoppingCart
} from '@material-ui/icons'
import Emoji from '../../assets/Images/Emoji1.png'

const { REACT_APP_STRAPI_API_URL } = process.env

function SearchStart() {
  const [searchDomainTitle, setSearchDomainTitle] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
        )
        const json = await response.json()
        setSearchDomainTitle(json?.data[0]?.attributes)
      } catch (error) {}
    }
    fetchData()
  }, [])

  const [bulkSeletions, setBulkSeletion] = useState()
  const getBulkSeletionData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/bulk-selections`
    ).then(response => response.json())
    setBulkSeletion(response?.data)
  }
  useEffect(() => {
    getBulkSeletionData()
  }, [])

  const [registers, setRegister] = useState()
  const getRegisterData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/search-registration-processes?populate=img`
    ).then(response => response.json())
    setRegister(response?.data)
  }
  useEffect(() => {
    getRegisterData()
  }, [])

  const [buttons, setButton] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/button-apis`
        )
        const json = await response.json()
        setButton(json?.data[0]?.attributes)
      } catch (error) {}
    }
    fetchData()
  }, [])

  return (
    <>
      <div class="borderboxwrap">
        <div class="title-col1">
          <h1>{searchDomainTitle?.title}</h1>
        </div>
        <form class="searchcolwrap">
          <input type="search" name="search" placeholder="Search" />
          <Button className="btnSearchStart">
            <a href="/listReject">
              <Search />
              {buttons?.avax}
            </a>
          </Button>
        </form>
        <section className="domainavailablewrap">
          <Container>
            <Grid item xs={12} className="domainwrap">
              <Grid
                container
                item
                xl={6}
                lg={6}
                md={6}
                sm={12}
                xs={12}
                className="domainwrapbox1_1"
              >
                <h3>The Domain Is Available</h3>
                <h5>
                  melissa.<span>avax</span>
                </h5>
                <h4>
                  <span className="favoritesvg">
                    <FavoriteOutlined style={{ color: '#C4C4C4' }} />
                  </span>
                  "Favorite this name for easy access."
                </h4>
              </Grid>
              <Grid
                item
                xl={6}
                lg={6}
                md={6}
                sm={12}
                xs={12}
                className="domainwrapbox1_2"
              >
                <h4>FOREVER YOURS</h4>
                <h2>0.050 AVAX</h2>
                <h5>$154.98USD</h5>
                <button className="requestregbtn">
                  Request a Registration
                </button>
              </Grid>
            </Grid>
          </Container>
        </section>

        <section className="register registerwrap">
          <Container>
            <Grid item xs={12}>
              <h1>{searchDomainTitle?.RegisterTitle}</h1>
            </Grid>
            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              {registers &&
                registers.map(register => (
                  <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <div className="registerCard">
                      <div className="card">
                        <img
                          src={
                            REACT_APP_STRAPI_API_URL +
                            register?.attributes?.img?.data[0]?.attributes.url
                          }
                          alt=" "
                          class="img-fluid"
                        />
                        <Typography variant="h4">
                          {register.attributes.name}111
                        </Typography>
                        <Typography component="p">
                          {register.attributes.content}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </Container>
        </section>

        <Container>
          <div class="greataltwrap">
            <Button class="btnstyle3">
              {searchDomainTitle?.bulkSeletionTitle}
            </Button>
            <ul className="greaaltlist">
              {bulkSeletions &&
                bulkSeletions.map(bulkSeletion => (
                  <li>
                    <div class="colleft">
                      <Typography variant="h3">
                        {bulkSeletion.attributes.name}
                        <span>.avax</span>
                      </Typography>
                    </div>
                    <div class="colright">
                      <div class="infocol">
                        {bulkSeletion.attributes.value}
                        <Typography variant="h6">
                          {bulkSeletion.attributes.content}
                        </Typography>
                      </div>
                      <div class="rightcarticon">
                        <ShoppingCart />
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </Container>
      </div>
    </>
  )
}

export default SearchStart
